<template>
  <v-container class="!flex" fill-height>
    <v-layout row align-center justify-center wrap class="gap-2">
      <password-policy-check ref="pwdPolicy" :newPassword="modified.userNewPass" />
      <v-flex class="!flex !flex-col" xl4 md6 sm10 xs11>
        <v-alert :value="true" type="info" class="mb-2">{{ $t('CreatePassword.Infos') }}</v-alert>
        <v-container @keydown.enter="submit" class="!flex text-xs-center grey lighten-4">
          <v-card flat class="w-full">
            <v-card-title primary-title>
              <h4>{{ $t('CreatePassword.Title') }}</h4>
            </v-card-title>
            <v-form ref="form" :lazy-validation="true">
              <v-text-field
                v-model="modified.userLogin"
                ref="userName"
                prepend-icon="mdi-account"
                name="UserName"
                :label="$t('Login.Username')"
                :rules="[ruleRequired]"
                :validate-on-blur="true"
              ></v-text-field>
              <v-text-field
                :type="showNewPassword ? 'text' : 'password'"
                ref="newPassword"
                prepend-icon="mdi-lock"
                v-model="modified.userNewPass"
                :append-outer-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-outer="showNewPassword = !showNewPassword"
                name="NewPassword"
                :label="$t('CreatePassword.NewPassword')"
                :rules="[ruleRequired]"
                :validate-on-blur="true"
              ></v-text-field>
              <v-text-field
                :type="showConfirmNewPassword ? 'text' : 'password'"
                ref="confirmPassword"
                prepend-icon="mdi-lock"
                v-model="modified.userPass"
                :append-outer-icon="showConfirmNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append-outer="showConfirmNewPassword = !showConfirmNewPassword"
                name="ConfirmNewPassword"
                :label="$t('CreatePassword.ConfirmNewPassword')"
                :rules="[ruleRequired, rulePasswordMatch]"
                :validate-on-blur="true"
              ></v-text-field>
              <v-card-actions>
                <v-btn :disabled="!isValid || loading" :loading="loading" @click="submit" color="primary" large block>
                  {{ $t('CreatePassword.SendRequest') }}
                </v-btn>
              </v-card-actions>
              {{ $store.myGetters.authStatus }}
            </v-form>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AlqForgottenPass } from '@/models/query/AlqForgottenPass'
import * as rules from '@/utils/validationRules'
import PasswordPolicyCheck from '@/components/shared/PasswordPolicyCheck.vue'

@Component({
  name: 'CreatePassword',
  components: { PasswordPolicyCheck },
})
export default class CreatePassword extends Vue {
  modified = new AlqForgottenPass()
  dirtyEmail = false
  dirtyPwd = false
  dirtyConfirmPwd = false
  loading = false

  showNewPassword = false
  showConfirmNewPassword = false

  created() {
    this.modified = {
      ...new AlqForgottenPass(),
      userLogin: (this.$route.query.login as string) ?? '',
      userEncryptedToken: (this.$route.query.token as string) ?? '',
    }
  }

  ruleRequired(v: string) {
    return rules.ruleRequired(v)
  }
  rulePasswordMatch(v: string) {
    return rules.rulePasswordMatch(v, this.modified.userNewPass)
  }
  ruleMailValid(v: string) {
    return rules.ruleMailValid(v)
  }

  get redirectPath() {
    this.modified.userLogin
    return this.$store.myGetters.redirectPath
  }

  beforeDestroy() {}

  @Watch('dirtyLogin')
  dirtyEmailChanged(newValue: boolean) {
    //@ts-ignore
    if (newValue) this.$refs.login.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch('dirtyPwd')
  dirtyPwdChanged(newValue: boolean) {
    //@ts-ignore
    if (newValue) this.$refs.newPassword.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch('dirtyConfirmPwd')
  dirtyConfirmPwdChanged(newValue: boolean) {
    //@ts-ignore
    if (newValue) this.$refs.confirmPassword.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  mounted() {
    this.hackToSolveAutoFillIssue()
    this.$store.myActions.AUTH_RESET_STATUS()
    this.$vuetify.theme.primary = '#4066aa'
    this.$vuetify.theme.secondary = '#ec7404'
  }

  hackToSolveAutoFillIssue() {
    let times = 0
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyEmail && this.dirtyPwd && this.dirtyConfirmPwd) || times === 30) {
        clearInterval(interval)
      } else {
        this.dirtyEmail = !!document.querySelector('input[name="UserName"]:-webkit-autofill')
        this.dirtyPwd = !!document.querySelector('input[name="NewPassword"]:-webkit-autofill')
        this.dirtyConfirmPwd = !!document.querySelector('input[name="ConfirmNewPassword"]:-webkit-autofill')
      }
    }, 100)
  }

  get isValid() {
    return (
      this.rulePasswordMatch(this.modified.userPass) &&
      this.ruleRequired(this.modified.userLogin) &&
      this.$refs.pwdPolicy &&
      //@ts-ignore
      this.$refs.pwdPolicy.isValid
    )
  }

  submit() {
    if ((this.$refs.form as HTMLFormElement).validate() && this.isValid) {
      this.loading = true
      this.$store.myActions
        .AUTH_CREATE_PASSWORD_REQUEST(this.modified)
        .then(() => {
          this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.$t('CreatePassword.PasswordChanged').toString()) //"Mot de passe modifié avec succès.")
          this.$store.myActions.AUTH_USER_REQUEST().then(() => {
            this.$router.push({ name: 'Home' })
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
